import styled from 'styled-components';
import Card from '@material-ui/core/Card';

export const Container = styled.div`
  display: flex;
  height: 90vh;
  align-items: center;
  flex-direction: column;
`;
export const Header = styled.div`
  display: flex;
  align-items: center;
  height: 60px;
  border-bottom: 1px solid #dddddd;

  span {
    color: #333333;
  }
`;
export const Form = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  padding: 20px;
`;

export const Cards = styled(Card)`
`;

export const RowInput = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ColumnForm = styled.div`
  justify-content: center;
  flex-direction: column;
  flex: 1;
`;
export const RowForm = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  margin-top: 30px;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }
`;
export const Footer = styled.div`
  background-color: #F2F2F2;
  height: 60px;
  display: flex;
  margin-top: 20px;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;

  div {
    width: 170px;
  }
`;
export const ContainerTurn = styled.div`
  display: flex;
  flex-direction: column;
`;
export const DaysContainer = styled.div`
  display:  flex;
  justify-content: space-between;
  flex-direction:  row;
`;
export const PeriodoContainer = styled.div`
  margin: 0px 0px 20px 10px;
  display:  flex;
  justify-content: space-evenly;
  flex-direction:  column;
`;
export const RowSelect = styled.div`
  display: flex;
  flex-direction: row;
`;
export const ContainerRow = styled.div`
  display: flex;
  flex-direction: row;
`;
export const FooterTurn = styled.div`
  display: flex;
  flex-direction: row;
`;
export const FooterTurnContainerRight = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 95px;

div {
  width: 200px;
  margin-right: 6px;
}
`;
export const Padding = styled.div`
  display: flex;
  width: 100%;
  margin-right: 10px;
`;
export const ContainerImage = styled.div`
  display: flex;
  max-width: 60%;
  margin-bottom: 20px;

  @media only screen and (max-width: 600px) {
    margin-top: 20px;
  }
`;
export const ContainerLoading = styled.div`
display: flex;
justify-content: center;`;

export const style = {
  column: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  img: {
    marginBottom: 40,
  },
  input: {
    marginBottom: 30,
  },
  text: {
    fontSize: 12,
    marginRight: 10,
    color: 'white',
    backgroundColor: '#333333',
    fontFamily: 'Graphik-Regular',
  },
  textSave: {
    fontSize: 12,
    marginRight: 10,
    color: 'white',
    backgroundColor: 'green',
    fontFamily: 'Graphik-Regular',
  },
  textButton: {
    fontSize: 12,
    marginTop: 20,
    marginBottom: 15,
    marginLeft: 16,
    color: 'white',
    backgroundColor: '#333333',
    fontFamily: 'Graphik-Regular',
  },
  textButtonTurno: {
    fontSize: 12,
    marginTop: 20,
    marginBottom: 15,
    marginLeft: 0,
    color: 'white',
    backgroundColor: '#333333',
    fontFamily: 'Graphik-Regular',
  },
};
